//------------------------------------------------------------------------------------
//	Polygonia: Plot Polygons
//
//
//
//------------------------------------------------------------------------------------

import { BasicUnits, PolygonMiterType, PolygonList, MathUtil, SegmentList, Polygon_FindBounds } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { GenerateDXF, GenerateSVG } from "../../VectorUtilsJS/src/VectorFileLib.js";
import { VectorCornerStyle } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { Transform } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { GfxPath, GfxDrawing } from "../../GfxContainer/src/GfxDrawing.js";
import { GfxRender } from "../../GfxContainer/src/GfxRender.js";
import { GetPolygonTransformList } from "./PolygonTransforms.js";
import { ColorPicker } from "./ColorPicker.js"

//------------------------------------------------------------------------------------
//
//	Polygonia Polygons Plot
//
//------------------------------------------------------------------------------------
var PolygoniaPolygonsPlot = (function() 
{
	// Canvas rendering
	var theCanvas;
	var theContext;
	// Zoom
	var theTransform = undefined;
	// Design (polygons) 
	var theSourceDesign = undefined;
	var theDesign = undefined;
	// Gfx Paths
	var thePolygonsPath = undefined;
	//var theDesignPath = undefined;
	var theDesignDrawing = undefined;
	// Design info
	var theSourceBounds;
	var theBounds;
	// Under the mouse
	var theDesignTestPt = undefined;
	var theHoverPolygons = [];
	/*
	var theTestPolygons = [];
	var theTestIntersections = [];
	*/
	
	// Function list and current function
	var plotList = [];
	
	// Misc
	var noPolygonsMsg = "Drag JSON polygons here";
	var theMouseTracking = undefined;
	let epsilon = 0.0000001;

	// Settings and Controls
	var theSettings = {}; // built from control list
	var theCurrentTransform = undefined;

	var generalControlList = [
		{ id:"ID_OutputSizeEnable",		initial:false,		handler:"click",	access:"checked",	property:"outputSizeEnable"					},
		{ id:"ID_OutputWidth",			initial:100,		handler:"input",	access:"value",		property:"outputWidth",		isFloat:1		},
		{ id:"ID_OutputHeight",			initial:100,		handler:"input",	access:"value",		property:"outputHeight",	isFloat:1		},
		{ id:"ID_OutputMargin",			initial:0,			handler:"input",	access:"value",		property:"outputMargin",	isFloat:1		},
		{ id:"ID_ShowPages",			initial:false,		handler:"click",	access:"checked",	property:"showPages"						},
		{ id:"ID_CenterDesign",			initial:false,		handler:"click",	access:"checked",	property:"centerDesign"						},

		{ id:"ID_IncludeFrame",			initial:true,		handler:"click",	access:"checked",	property:"includeFrame"						},
		{ id:"ID_FrameLineWidth",		initial:0.30,		handler:"input",	access:"value",		property:"frameLineWidth",		isFloat:1	},
		{ id:"ID_FrameColor", 			initial:"#000000", 	handler:"change",	access:"value",		property:"frameLineColor",		regen:false	},	
		{ id:"ID_IncludePolygons",		initial:false,		handler:"click",	access:"checked",	property:"includePolygons"					},
		{ id:"ID_PolygonLineWidth",		initial:0.30,		handler:"input",	access:"value",		property:"polygonLineWidth",	isFloat:1	},
		{ id:"ID_PolygonColor", 		initial:"#000000", 	handler:"change",	access:"value",		property:"polygonLineColor",	regen:false	}
	];
	
	var transformControlList = [

		{ id:"cPercent",				initial:0.2,		handler:"input",	access:"value",		property:"tParam",			isFloat:1		},
		{ id:"cCount",					initial:20,			handler:"input",	access:"value",		property:"count",			isFloat:1		},
		{ id:"cSpacing",				initial:3,			handler:"input",	access:"value",		property:"spacing",			isFloat:1		},
		{ id:"cLineWidth",				initial:0.30,		handler:"input",	access:"value",		property:"lineWidth",		isFloat:1		},
		{ id:"cOffset",					initial:0.0,		handler:"input",	access:"value",		property:"offset",			isFloat:1		},
		{ id:"cIncludePolygon",			initial:false,		handler:"click",	access:"checked",	property:"includePolygon"					},
		{ id:"cIgnoreConcave",			initial:false,		handler:"click",	access:"checked",	property:"ignoreConcave"					},
		{ id:"cStringStyle",			initial:0,			handler:"change",	access:"value",		property:"stringStyle"						},
		{ id:"cTwistStyle",				initial:0,			handler:"change",	access:"value",		property:"twistStyle"						},
		{ id:"cColor", 					initial:"#000000", 	handler:"change",	access:"value",		property:"lineColor",		regen:false		},	
	];
	
	//------------------------------------------------------------------------------------
	//	Init
	//------------------------------------------------------------------------------------
	var Init = function()
	{
		// Get the canvas and context where we will render the polygons
		theCanvas = document.getElementById('ID_Canvas');
		theContext = theCanvas.getContext("2d");

		// ??
		theCanvas.width = theCanvas.clientWidth;
		theCanvas.height = theCanvas.clientHeight;

		// 
		theTransform = new Transform();
		
		// Create settings
		theSettings = BuildSettingsFromControlLists();
		theCurrentTransform = theSettings.transforms[0];
		

		// Register the drag event handler for all of the drag events, although
		// we will ignore some of them
		let dragEvents = ["dragend", "dragexit", "dragenter", "dragleave", "dragover", "drop"];
		dragEvents.forEach(evtName => theCanvas.addEventListener(evtName, evt => HandleDrag(evt, evtName), false));
		
		// Register mouse events
		let mouseEvents = ["mousedown", "mousemove", "mouseup", "mouseleave"]
		mouseEvents.forEach(evtName => theCanvas.addEventListener(evtName, evt => HandleMouse(evt, evtName), false));
	
		theCanvas.addEventListener("wheel",      HandleMouseWheel /*,  {passive: true}*/);

		// Create a list of plot functions. These will be used by BuildUI.
		let xf = GetPolygonTransformList();
		for (var i = 0; i < xf.length;i++)
		{
			plotList.push({name:xf[i].name, func:xf[i].func});
		}
		
		// Create the radio button to select the plot
		BuildTransformSelectionUI();
		
		ColorPicker.Init();

		// Connect the general controls
		ConnectUI();
		
		let e = document.querySelector(".cTransformContainer");
		ConnectTransformSettingsUI(e, theSettings.transforms[0]);
		AdjustTransformSettingsUI(e, 0);
		
		// Set-up the handler to handle resize events and also call the handler
		// directly for the initial set-up. This will also render everything
		window.addEventListener("resize", ResizeWindowHandler, false);
		
		// Create a list of samples
		AddPolygonSamples();
		
		let buttons = ["ID_SaveSVG", "ID_SavePolygons", "ID_SaveDesign", "ID_ZoomToDesign", "ID_ZoomToPage"];
		buttons.forEach(id => {
				let e = document.getElementById(id);
				e.addEventListener("click", HandleButton);
			});
				
		// Initial render of the canvas, to show the "Drag here" message
		RenderDesign();
	}
	
	//------------------------------------------------------------------------------------
	//	Build Settings From Control Lists
	//------------------------------------------------------------------------------------
	var BuildSettingsFromControlLists = function()
	{
		var settings = {}
		
		// For each control, add a property to the settings object
		generalControlList.forEach(c => settings[c.property] = c.initial);
		
		// Note: for the first transformSettings we don't set a "polygonIdxList"
		var transformSettings = {}
		
		transformSettings.transformIdx = 0; // First 'polygon transform' function: "basic"
		
		transformControlList.forEach(c => transformSettings[c.property] = c.initial);
		
		settings.transforms = [transformSettings];
		
		return settings;
	}
	
	//------------------------------------------------------------------------------------
	//	Add Polygon Samples
	//------------------------------------------------------------------------------------
	var AddPolygonSamples = function()
	{
		// Add sample buttons (if we are running on a server)
		if (document.location.origin.substring(0, 4) == "http")
		{
			var samples = [];
			
			samples.push({name:"Flower", 		ref:"./Symmetry/FlowerPolygons.json"});
			samples.push({name:"Squarish", 		ref:"./Symmetry/SquarishPatternPolygons.json"});
			samples.push({name:"Rosettes", 		ref:"./Symmetry/RosettesPatternPolygons.json"});
			samples.push({name:"TriHexSmall", 	ref:"./Symmetry/TriHexSmallPolygons.json"});
			samples.push({name:"Triangles", 	ref:"./Symmetry/MultipleTrianglesPolygons.json"});

			samples.push({name:"Another", 		ref:"./Symmetry/AnotherPolygons.json"});
			samples.push({name:"HexBars", 		ref:"./Symmetry/HexBarsPolygons.json"});
			samples.push({name:"HexCrossbars", 	ref:"./Symmetry/HexCrossbarsPolygons.json"});
			samples.push({name:"HexFlakes", 	ref:"./Symmetry/HexFlakesPolygons.json"});
			samples.push({name:"HexPanels", 	ref:"./Symmetry/HexPanelsPolygons.json"});
			samples.push({name:"More", 			ref:"./Symmetry/MorePolygons.json"});
			samples.push({name:"TriangleNet", 	ref:"./Symmetry/TriangleNetPolygons.json"});
			samples.push({name:"TriHexKites", 	ref:"./Symmetry/TriHexKitesPolygons.json"});
			samples.push({name:"TriHex", 		ref:"./Symmetry/TriHexPolygons.json"});
			
			AddSampleButtons(samples);
			
			noPolygonsMsg = "Drag JSON polygons here or click button, below";
		}
	}
	
	//------------------------------------------------------------------------------------
	//	get Mouse Pos
	//------------------------------------------------------------------------------------
	function getMousePos(aCanvas, evt) {

		var rect = aCanvas.getBoundingClientRect();
		var mouseX = (evt.changedTouches ? evt.changedTouches[0].clientX : evt.clientX) - rect.left; //this.offsetLeft;
		var mouseY = (evt.changedTouches ? evt.changedTouches[0].clientY : evt.clientY) - rect.top; //this.offsetTop;
		var insetX = 1; // These match the border on the canvas. Hardcoding is less
		var insetY = 1; // expensive than computing the style
		return {
			x: mouseX - insetX,
			y: mouseY - insetY
		};
	}

	//------------------------------------------------------------------------------------
	//	Connect (general) UI
	//------------------------------------------------------------------------------------
	var ConnectUI = function()
	{
		for (var i = 0; i < generalControlList.length; i++)
		{
			let ctl = generalControlList[i];
			let c = document.getElementById(ctl.id);
						
			if (c != undefined)
			{
				c.addEventListener(ctl.handler, evt => HandleControl(evt, ctl, theSettings));

				c[ctl.access] = ctl.initial;

				if (ctl.id.includes("Color") && ctl.access == "value")
					c.setAttribute("value", ctl.initial);
			}
			else
			{
				console.log("Missing '" + ctl.id + "'");
			}
		}
	}
	
	//------------------------------------------------------------------------------------
	//	Reset Design Settings
	//------------------------------------------------------------------------------------
	var ResetDesignSettings = function()
	{
		// Remove all of the transforms	
		theSettings = BuildSettingsFromControlLists();
		theCurrentTransform = theSettings.transforms[0];
			
		let addedTransformSettings = document.querySelectorAll(".cTransformSettings-added");
		addedTransformSettings.forEach(e => e.remove());
		
		PopulateGeneralControls();
		let e = document.querySelector(".cTransformContainer");
		//PopulateTransformSettings(e, theSettings.transforms[0]);
		ConnectTransformSettingsUI(e, theSettings.transforms[0]);
	}
	
	var PopulateGeneralControls = function()
	{
		for (var i = 0; i < generalControlList.length; i++)
		{
			let ctl = generalControlList[i];
			let c = document.getElementById(ctl.id);
						
			if (c != undefined)
			{
				c[ctl.access] = theSettings[ctl.property];

				if (ctl.id.includes("Color") && ctl.access == "value")
					c.setAttribute("value", ctl.initial);
			}
		}
	}

	var PopulateTransformSettings = function(transformSettingsElement, transformSettings)
	{
		for (var i = 0; i < transformControlList.length; i++)
		{
			let ctl = transformControlList[i];
			let c = transformSettingsElement.querySelector("." + ctl.id);
			
			if (c != undefined)
			{
				c[ctl.access] = transformSettings[ctl.property];
				if (ctl.id.includes("Color") && ctl.access == "value")
					c.setAttribute("value", transformSettings[ctl.property]);
			}
			else
				console.log("Missing '" + ctl.id + "'");
		}
		
		let id = "." + "pTransform_" + transformSettings.transformIdx;
		let c = transformSettingsElement.querySelector(id);
		
		if (c != undefined)
			c["checked"] = true;
	}
	
	//------------------------------------------------------------------------------------
	//	Set Design Settings
	//------------------------------------------------------------------------------------
	var SetDesignSettings = function(settings)
	{
		var inTransforms = [];
		ResetDesignSettings();
		
		if (settings != undefined)
		{
			var transformSettings = theSettings.transforms[0];
			
			// Move the incoming transforms list to another variable
			inTransforms = settings.transforms;
			settings.transforms = undefined;

			Object.assign(theSettings, settings);
			Object.assign(transformSettings, inTransforms[0]);
			theSettings.transforms = [transformSettings];
		}
		
		PopulateGeneralControls();

		let e = document.querySelector(".cTransformContainer");
		PopulateTransformSettings(e, theSettings.transforms[0]);
		AdjustTransformSettingsUI(e, 0);
		
		for (var i = 1; i < inTransforms.length; i++)
		{
			var transformSettingsElement = AddTransformSettings(e, inTransforms[i]);
			AdjustTransformSettingsUI(transformSettingsElement, i);
		}
	}

	//------------------------------------------------------------------------------------
	//	Connect Transform Settings UI
	//------------------------------------------------------------------------------------
	var plotGroupNumber = 1;
	var ConnectTransformSettingsUI = function(transformSettingsElement, transformSettings)
	{
		let settings = transformSettings;
		
		
		for (var i = 0; i < transformControlList.length; i++)
		{
			let ctl = transformControlList[i];
			let c = transformSettingsElement.querySelector("." + ctl.id);
			
			if (c != undefined)
			{
				c.addEventListener(ctl.handler, evt => HandleControl(evt, ctl, settings));
				c[ctl.access] = transformSettings[ctl.property];

				if (ctl.id.includes("Color") && ctl.access == "value")
					c.setAttribute("value", transformSettings[ctl.property]);
			}
			else
			{
				console.log("Missing '" + ctl.id + "'");
			}
		}
		
		// Assign a unique name to each group of radio buttons
		let plotGroupName = "plot_" + plotGroupNumber;
		plotGroupNumber++;
		
		for (var i = 0; i < plotList.length; i++)
		{
			let id = "." + "pTransform_" + i;
			let c = transformSettingsElement.querySelector(id);
			
			if (c != undefined)
			{
				c.addEventListener("click", evt => HandleTransformSelectionUI(evt, settings, transformSettingsElement));
				c.setAttribute("name", plotGroupName);
			}
			else
			{
				console.log("Missing '" + id + "'");
			}
		}

		// "Check" the radio button after setting the "name" attribute of all of the buttons
		for (var i = 0; i < plotList.length; i++)
		{
			let id = "." + "pTransform_" + i;
			let c = transformSettingsElement.querySelector(id);
			
			if (c != undefined && transformSettings.transformIdx == i)
				c["checked"] = true;
		}
		
		var btn;
		btn = transformSettingsElement.querySelector(".pAddTransformButton");
		if (btn != undefined)
			btn.addEventListener("click", evt => AddTransformSettings(transformSettingsElement, settings));

		btn = transformSettingsElement.querySelector(".pRemoveTransformButton");
		if (btn != undefined)
			btn.addEventListener("click", evt => RemoveTransformSettings(transformSettingsElement, settings));
			
		let cp = transformSettingsElement.querySelector("colorpicker");
		ColorPicker.Connect(cp);
		
		transformSettingsElement.addEventListener("click", evt => SelectTransformSettings(transformSettingsElement, settings));

	}
	
	//------------------------------------------------------------------------------------
	//	Select Transform Settings
	//------------------------------------------------------------------------------------
	var SelectTransformSettings = function(transformSettingsElement, transformSettings)
	{
		let pList = document.querySelectorAll(".cTransformSettings-current");
		pList.forEach(e => e.classList.remove("cTransformSettings-current"));

		transformSettingsElement.classList.add("cTransformSettings-current");
		
		theCurrentTransform = transformSettings;
	}

	//------------------------------------------------------------------------------------
	//	Add Transform Settings
	//------------------------------------------------------------------------------------
	var AddTransformSettings = function(transformSettingsElement, transformSettings)
	{		
		var newTransformSettings = {}
		transformControlList.forEach(c => newTransformSettings[c.property] = transformSettings[c.property]);
		newTransformSettings.transformIdx = transformSettings.transformIdx;
		
		// For new transform settings, we add an empty polygonIdxList
		newTransformSettings.polygonIdxList = [];
		
		if (transformSettings.polygonIdxList)
			transformSettings.polygonIdxList.forEach(idx => newTransformSettings.polygonIdxList.push(idx));
		
		let container = document.getElementById("ID_SettingsCollection");
		
		theSettings.transforms.push(newTransformSettings);
		//let idx = theSettings.transforms.length - 1;
		
		let newTransformSettingsElement = transformSettingsElement.cloneNode(true);
		newTransformSettingsElement.classList.remove("cTransformSettings-current");
		newTransformSettingsElement.classList.add("cTransformSettings-added");
		
		
		ConnectTransformSettingsUI(newTransformSettingsElement, newTransformSettings);
		
		
		let btn = newTransformSettingsElement.querySelector(".pRemoveTransformButton");
		if (btn != undefined)
			btn.classList.remove("hide-element");

		container.appendChild(newTransformSettingsElement);

		return newTransformSettingsElement;
	}
	
	//------------------------------------------------------------------------------------
	//	Remove Transform Settings
	//------------------------------------------------------------------------------------
	var RemoveTransformSettings = function(transformSettingsElement, transformSettings)
	{
		// Remove transform settings from the list
		let idx = theSettings.transforms.indexOf(transformSettings);
		
		if (idx != -1)
			theSettings.transforms.splice(idx, 1);
		else
			console.log("RemoveTransformSettings: did not find transformSettings in list");
		
		// Remove from DOM
		transformSettingsElement.remove();

		UpdateDesign();
		RenderDesign();
	}
	
	//------------------------------------------------------------------------------------
	//	Adjust Transform Settings UI
	//		Hide or show the appropriate parameters for the current transform
	//------------------------------------------------------------------------------------
	var AdjustTransformSettingsUI = function(transformSettingsElement, transformIdx)
	{
		// First, hide all of the "optional parameter" elements		
		let pList = transformSettingsElement.querySelectorAll(".pParam");
		pList.forEach(e => e.classList.add("hide-element"));

		// Get the list of parameters that are relevant to this transform		
		let xf = GetPolygonTransformList();
		let pShowList = xf[transformIdx].settings;
		
		// And show them
		for (var i = 0; i < pShowList.length; i++)
		{
			let q = "." + pShowList[i]; 
			let e = transformSettingsElement.querySelector(q);
			if (e != undefined)
				e.classList.remove("hide-element");
			else
				console.log("AdjustTransformSettingsUI: missing '" + q + "'");
		}
	}

	//------------------------------------------------------------------------------------
	//	Handle Control
	//------------------------------------------------------------------------------------
	var HandleControl = function(evt, ctl, settings)
	{
		var value = evt.target[ctl.access];
		
		if (ctl.isFloat)
			value = parseFloat(value);
			
		settings[ctl.property] = value;
		
		// For color changes we don't need to regenerate the design
		//if (ctl.regen == undefined || ctl.regen)
			UpdateDesign();
		//else
		//	UpdateDesignColorAndLine();
			
		RenderDesign();
	}

	//------------------------------------------------------------------------------------
	//	Build Transform Selection UI
	//		Add radio button to the page to select the plot
	//------------------------------------------------------------------------------------
	var BuildTransformSelectionUI = function()
	{
		let container = document.querySelector(".cTransformSelection");
		
		// For each plot in the plot list,...
		for (var i = 0; i < plotList.length; i++)
		{
			// ...Create a div to hold...
			var div = document.createElement("div");
			div.classList.add("radio-div");
			container.appendChild(div);
			
			// ...a radio button, and...
			var radio = document.createElement("input");
			radio.classList.add("radio-button");
			radio.classList.add("pTransform_" + i);
			radio.setAttribute("type", "radio");
			radio.setAttribute("name", "plot");
			radio.dataset.plotIdx = i;
			if (i == 0)
				radio.checked = true;
			//radio.addEventListener("click", HandleRadio);

			// ...a label
			var label = document.createElement("label");
			label.classList.add("radio-label");
			let t = document.createTextNode(plotList[i].name);
			label.appendChild(radio);
			label.appendChild(t);
			div.appendChild(label);
		}
	}

	//------------------------------------------------------------------------------------
	//	Add Sample Buttons
	//------------------------------------------------------------------------------------
	var AddSampleButtons = function(sampleList)
	{
		let container = document.getElementById("ID_Samples");
		
		for (var i = 0; i < sampleList.length && container != undefined; i++)
		{
			let button = document.createElement("button");
			button.innerHTML = sampleList[i].name;
			button.classList.add("sampleButton");
			button.dataset.sample = sampleList[i].ref;
			button.addEventListener("click", LoadSampleButton);
			container.appendChild(button);
		}
	}
	
	//------------------------------------------------------------------------------------
	//	Load Sample Button
	//------------------------------------------------------------------------------------
	var LoadSampleButton = function(evt)
	{
		const url = evt.target.dataset.sample;

		fetch(url)
		.then( r => 
		{
			if (r.status >= 200 && r.status <= 299)
				return r.text();
			else
				throw Error(r.statusText)
		} )
		.then( t => ProcessPossibleJSON(t) )	
		.catch (err => {console.log(err); ReportMessage("Unable to load polygons from server");});
	}

	//------------------------------------------------------------------------------------
	//	Handle Radio
	//------------------------------------------------------------------------------------
	var HandleTransformSelectionUI = function(evt, settings, transformSettingsElement)
	{
		// Select a different plot
		let idx = evt.target.dataset.plotIdx;
		
		if (idx >= 0 && idx < plotList.length)
		{
			settings.transformIdx = idx;
			
			AdjustTransformSettingsUI(transformSettingsElement, idx);
			
			if (theDesign != undefined)
			{
				RegenerateDesignPath();
				RenderDesign();
			}
		}
	}
	
	//-------------------------------------------------------------------------------------
	//	Generate SVG
	//-------------------------------------------------------------------------------------
	var GenerateSVGfromShapePaths = function(shapePaths)
	{
		var b = shapePaths.cutPath.FindBounds();
		var linewidth = 0.5;
		var offsetX = -b.min.x + linewidth;
		var offsetY = -b.min.y + linewidth;
		var exportW = b.max.x - b.min.x + 2 * linewidth;
		var exportH = b.max.y - b.min.y + 2 * linewidth;
			
		GenerateSVG.Start(exportW, exportH, BasicUnits.MILLIMETERS);
		GenerateSVG.SetInvertVertical(false);
		GenerateSVG.SetOffset(offsetX, offsetY);
		GenerateSVG.SetFillInfo(true, "#f8f8ff");
		GenerateSVG.SetStrokeInfo(true, "#000000", linewidth);
		GenerateSVG.AddGfxPath(shapePaths.cutPath);

/*
		GenerateSVG.SetFillInfo(false, "#ffffff");
		GenerateSVG.AddGfxPath(shapePaths.slotCutPath);

		GenerateSVG.SetFillInfo(false, "#ffffff");
		GenerateSVG.SetStrokeInfo(true, "#c0c0c0", linewidth/2);
		GenerateSVG.AddGfxPath(shapePaths.insideScorePath);
		GenerateSVG.AddGfxPath(shapePaths.edgeScorePath);
*/
	
		var svg = GenerateSVG.Finish();

		return svg;
	}

	//-------------------------------------------------------------------------------------
	//	Save As
	//-------------------------------------------------------------------------------------
	var ScreenDesignerFileIO_SaveAs = function(fileType /* svg, txt, dxf, png */, fileData, documentName)
	{
		//convert svg source to URI data scheme.
		var urlPrefix = "";
	
		if (fileType === "svg")
			urlPrefix = "data:image/svg+xml;charset=utf-8,";
		else if (fileType === "txt")
			urlPrefix = "data:text/plain;charset=utf-8,";
		else if (fileType === "json")
			urlPrefix = "data:text/plain;charset=utf-8,";
		else if (fileType === "dxf")
			urlPrefix = "data:text/plain;charset=utf-8,";
		else if (fileType === "png")
			urlPrefix = undefined; // Data is already prepared
		else if (fileType === "json")
			urlPrefix = "";
		else
			console.log("ScreenDesignerFileIO_SaveAs: Unknown fileType:" + fileType);
	
		var url = undefined;		
		if (urlPrefix != undefined)
			url = urlPrefix + encodeURIComponent(fileData);
		else
			url = fileData;

		var docName = documentName + "." + fileType;
	
		var a = document.getElementById("ID_ExportElement");
		if (a != undefined)
		{
			a.href = url;
			a.download = docName;
			a.click();
		}
		else
		{
			console.log("ScreenDesignerFileIO_DownloadURLData_priv: missing 'ID_ExportElement'");
		}
	}

	var ScreenDesignerFileIO_SaveAsBlob = function(fileType /* svg, dxf */, fileData, documentName)
	{
		try {
			var docName = documentName + "." + fileType;
			var blobType = "";

			if (fileType === "svg")
				blobType = "image/svg+xml;charset=utf-8,";
			else if (fileType === "dxf")
				blobType = "text/plain;charset=utf-8,";
			else if (fileType === "stl")
				blobType = "text/plain;charset=utf-8,";
			else
				console.log("ScreenDesignerFileIO_SaveAsBlob: Unknown fileType:" + fileType);

			var blob = new Blob([fileData], {type: blobType});
			var url = URL.createObjectURL(blob);

			// Handler to clean-up the URL after the download
			var clickHandler = function()
			{
				requestAnimationFrame(function() {
					URL.revokeObjectURL(element.href);
				})

				a.removeAttribute('href')
				a.removeEventListener('click', clickHandler)
			};

			// Create an element to perform the download and then clean-up
			var a = document.createElement('a');
			a.setAttribute('href', url);
			a.setAttribute('download', docName);
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			a.addEventListener('click', clickHandler);
			document.body.removeChild(a);
		}
		catch (err) {
			console.log("ScreenDesignerFileIO_SaveAsBlob");
			console.log(err);
		}
	}


	//------------------------------------------------------------------------------------
	//	Get File Name
	//------------------------------------------------------------------------------------
	var GetFileName = function()
	{
		var fileName = "untitled";
		
		let e = document.getElementById("ID_Name");
		if (e != undefined)
		{
			let v = e.value;
			if (v.length > 0)
				fileName = v;
		}
		
		return fileName;
	}

	//------------------------------------------------------------------------------------
	//	Save As SVG
	//------------------------------------------------------------------------------------
	var SaveAsSVG = function()
	{
		if (theDesignDrawing != undefined)
		{
			let svg = GfxRender.RenderGfxDrawingToSVG(theDesignDrawing);
			ScreenDesignerFileIO_SaveAs("svg", svg, GetFileName());
		}
	}
	
	//------------------------------------------------------------------------------------
	//	Save Polygons JSON
	//------------------------------------------------------------------------------------
	var SavePolygonsJSON = function()
	{
		if (theSourceDesign != undefined)
		{
			let str = JSON.stringify(theSourceDesign);
			ScreenDesignerFileIO_SaveAs("json", str, GetFileName());
		}
	}

	//------------------------------------------------------------------------------------
	//	Save Design JSON
	//------------------------------------------------------------------------------------
	var SaveDesignJSON = function()
	{
		if (theSourceDesign != undefined)
		{
			let designData = { theSettings: theSettings, theSourceDesign: theSourceDesign };
			let str = JSON.stringify(designData);
			ScreenDesignerFileIO_SaveAs("json", str, GetFileName());
		}
	}

	//------------------------------------------------------------------------------------
	//	Handle Button
	//------------------------------------------------------------------------------------
	var HandleButton = function(evt)
	{
		let id = evt.target.id;
		
		if (id == "ID_SaveSVG")
			SaveAsSVG();
		else if (id == "ID_SavePolygons")
			SavePolygonsJSON();
		else if (id == "ID_SaveDesign")
			SaveDesignJSON();
		else if (id == "ID_ZoomToDesign")
			ZoomTo("zoomToDesign");
		else if (id == "ID_ZoomToPage")
			ZoomTo("zoomToPage");
		else
			console.log("Button not handled: " + id);			
	}
	
	//------------------------------------------------------------------------------------
	//	Zoom To
	//------------------------------------------------------------------------------------
	var ZoomTo = function(zoomTarget)
	{
		SetTransformZoom(zoomTarget, 20);
		RenderDesign();
	}
	
	//------------------------------------------------------------------------------------
	//	Find Polygons Under Point
	//------------------------------------------------------------------------------------
	var FindPolygonsUnderPoint = function(polygonList, testPoint)
	{
		// returns true if the point is within the bounds, or just outside by the 'distance'
		const PtInBounds = (pt, b, d) => ( (b.min.x - d < pt.x) && (b.min.y - d < pt.y) && (pt.x < b.max.x + d) && (pt.y < b.max.y + d) )
	
		//theTestPolygons = [];
		//theTestIntersections = [];

		// List of polygon indices that contain the point
		var resultIdcs = [];
		var idcs = [];
		polygonList.polygons.forEach((pl, idx) => 
			{ 
				let bounds = MathUtil.FindPolygonBounds(pl.points)
				if (PtInBounds(testPoint, bounds, 0)) 
					idcs.push({idx:idx, bounds:bounds}); 
			})
	
		//idcs.forEach(e => theTestPolygons.push(e.idx));
		
		// For each polygon that contains the point, find the line that might contain the point
		for (var i = 0; i < idcs.length; i++)
		{
			let idx = idcs[i].idx;
			let b = idcs[i].bounds;
			let outPt = {x:b.min.x - 10, y:b.min.y - 3};
		
			let polyPoints = [];
		
			polyPoints = polygonList.polygons[idx].points;
		
			let crossCount = 0;
			for (var j = 0; j < polyPoints.length; j++)
			{
				let c = MathUtil.CalcSegmentIntersection(testPoint, outPt, polyPoints[j], polyPoints[(j + 1) % polyPoints.length]);
				if (c != undefined /*&& c.cCD > 0.0 && c.cd < 1.0*/)
				{
					crossCount++;
					//theTestIntersections.push(c.ptIntersection);
				}
			}
		
			if ((crossCount % 2) == 1)
				resultIdcs.push(idx);
		}
	
		return resultIdcs;

	}
	
	var EqualArrays = function(a, b)
	{
		if (a == undefined || b == undefined || a.length != b.length)
			return false;
			
		if (!a.every(v => b.includes(v)) && !b.every(v => a.includes(v)))
			return false;
			
		return true;
	}

	var mouseMoveRefPt = undefined;
	let moveThreshold = 4;
	
	var HandleMouse = function(evt, mouseAction)
	{
		var mousePt = getMousePos(theCanvas, evt);
	
		if (mouseAction == "mousedown" && evt.ctrlKey)
		{
			// Keep default right-click behavior
		}
		else if (mouseAction == "mousedown" && evt.metaKey)
		{
			theMouseTracking = mousePt;
			theCanvas.style.cursor = "grabbing";

			evt.preventDefault();			
		}
		else if (mouseAction == "mousedown")
		{
			if (theHoverPolygons.length > 0)
			{
				AddPolygonsToCurrentTransform(theHoverPolygons);
				RegenerateDesignPath();
				RenderDesign();
			}

			evt.preventDefault();			
		}
		else if (mouseAction == "mousemove")
		{
			if (theMouseTracking != undefined)
			{
				var delta = {x: mousePt.x - theMouseTracking.x, y: mousePt.y - theMouseTracking.y};

				theTransform.offset.x += delta.x;
				theTransform.offset.y += delta.y;
				
				RenderDesign();
				
				theMouseTracking.x = mousePt.x;
				theMouseTracking.y = mousePt.y;

				evt.preventDefault();			
			}
			else
			{
				// Show the polygon outline only if there is more than one transform
				if (theDesign != undefined && theSettings.transforms.length > 1)
				{
					if (mouseMoveRefPt == undefined || Math.abs(mousePt.x - mouseMoveRefPt.x) > moveThreshold || Math.abs(mousePt.y - mouseMoveRefPt.y) > moveThreshold)
					{
						mouseMoveRefPt = mousePt;
						let designPt = theTransform.reverse_xfrm(mousePt);
						theDesignTestPt = designPt;
						let idcs = FindPolygonsUnderPoint(theDesign.polygonList, designPt);
						
						// remove the frame
						idcs = idcs.filter(idx => {
								let info = theDesign.polygonList.polygons[idx].info; 
								return (info == undefined || !info.isFrame);
							});
						
						let prevList = theHoverPolygons;
						
						theHoverPolygons = idcs;
						
						if (!EqualArrays(prevList, theHoverPolygons))
						{
							RenderDesign();
						}
					}
				}
			}
		}
		else if (mouseAction == "mouseup" || mouseAction == "mouseleave")
		{
			theMouseTracking = undefined;
			theCanvas.style.cursor = "auto";

			evt.preventDefault();			
		}

// 		if (mouseAction == "mousedown" && !evt.ctrlKey)
// 		{
// 			evt.preventDefault();
// 			if (theDesign != undefined)
// 				RenderPolygons();
// 		}
// 		else if (mouseAction == "mouseup")
// 		{
// 			evt.preventDefault();
// 			if (theDesign != undefined)
// 				RenderDesign(theDesign);
// 		}
	}

	//------------------------------------------------------------------------------------
	//
	//------------------------------------------------------------------------------------
	var HandleMouseWheel = function(evt)
	{
		var mousePt = getMousePos(theCanvas, evt);
		
		// 2018.01.09: Added test for metaKey (command-key on Mac)
		// 2018.06.01: Provide option to ignore meta key
		// 2019.02.19: Show banner to let user know to hold meta key
		if (evt.metaKey)
		{
			var changePercent = 0.05;
			var lowerScaleLimit = 0.50; 
			
			var scaleChanged = theTransform.AdjustScaleAroundBy(mousePt, (evt.deltaY > 0) ? changePercent : -changePercent, lowerScaleLimit);
		
			if (scaleChanged)
			{
				RenderDesign();
			}

			evt.preventDefault();			
		}
		else
			DisplayHoldCommandKeyBanner(theCanvas.id);
	}

	//------------------------------------------------------------------------------------
	//
	//------------------------------------------------------------------------------------
	var holdCommandKeyMessageShown = []; // Stores timestamps per id
	var DisplayHoldCommandKeyBanner = function(id)
	{
		
		if (!holdCommandKeyMessageShown[id])
		{
			ScreenDesigner_DisplayMessageBanner("Press the command key ('&#8984;') to zoom with two fingers.");
			var d = new Date();
			holdCommandKeyMessageShown[id] = d.getTime();
		}
		else
		{
			// Reset after 15 seconds
			var d = new Date();
			var t = d.getTime() - holdCommandKeyMessageShown[id];
			if (t > 15000)	
				holdCommandKeyMessageShown[id] = undefined;
		}
	}

	//---------------------------------------------------------------------------
	// Resize Window Handler
	//---------------------------------------------------------------------------
	var ResizeWindowHandler = function()
	{
		theCanvas.width = theCanvas.clientWidth;
		theCanvas.height = theCanvas.clientHeight;
		
		RenderDesign();
	}

	//---------------------------------------------------------------------------
	// Display Message Banner
	//---------------------------------------------------------------------------
	var ScreenDesigner_DisplayMessageBanner = function(message, options = undefined)
	{
		// Create a div that will be shown as a "banner", set the message, and
		// add it to the body of the document. It will be displayed with the
		// animation ("fade in") that is part of the .message-banner class
		var banner = document.createElement("div");
		banner.classList.add("message-banner");

		// 2019.10.14: Added options
		if (options != undefined && options.size == "small")
			banner.classList.add("message-banner-small");
		if (options != undefined && options.position == "bottom")
			banner.classList.add("message-banner-bottom");

		banner.innerHTML = message;
		document.body.appendChild(banner); 

		// This clean-up function will be called by the timer, below. It will
		// add a "fade out" animation and an animationend listener. The listener
		// will simply remove the banner div from the document.
		function cleanUp(banner) {
			banner.classList.add("message-banner-fadeout");
			banner.addEventListener("animationend", function(evt) {document.body.removeChild(evt.target)}, false);		
		}
		setTimeout(cleanUp, 2000, banner);
	}

	//------------------------------------------------------------------------------------
	//	Handle Drag
	//------------------------------------------------------------------------------------
	var HandleDrag = function(evt, evtName)
	{
		// Drag enter: Show feedback if we can accept the item
		if (evtName == "dragenter")
		{
			var showFeedback = false;
			evt.preventDefault();

			for (var i = 0; i < evt.dataTransfer.items.length; i++)
			{
				let item = evt.dataTransfer.items[i];
				showFeedback = showFeedback || (item.type.match("^text/json") || item.type.match("^text/plain") || item.type.match("^application/json"));
			}
			DisplayDragFeedback(showFeedback);
		}
		// Drag leave: Remove any feedback
		else if (evtName == "dragleave")
		{
			evt.preventDefault();
			DisplayDragFeedback(false);
		}
		// Drag over: Prevent default event handling, otherwise we don't get the drop event
		else if (evtName == "dragover")
		{
			evt.preventDefault();
		}
		// Drop: Process the drop if it is something we recognize
		else if (evtName == "drop")
		{
			var done = false;
			evt.preventDefault();
			DisplayDragFeedback(false);

			for (var i = 0; i < evt.dataTransfer.items.length && !done; i++)
			{
				var item = evt.dataTransfer.items[i];
				
				// Is dropped item JSON or TEXT?
				if ((item.kind == 'string') && (item.type.match('^text/json') || item.type.match('^text/plain')))
				{
					item.getAsString(s => ProcessPossibleJSON(s));
					done = true;
				}
				// Or is dropped item a text file?
				else if ((item.kind == 'file') && (item.type.match('^application/json')))
				{
					// Drag data item is an image file
					var f = item.getAsFile();
					LoadFile(f)
					done = true;
				}
			}
		}
	}
	
	//------------------------------------------------------------------------------
	//	Display Drag Feedback
	//------------------------------------------------------------------------------
	var DisplayDragFeedback = function(showFeedback)
	{
		if (showFeedback)
			theCanvas.classList.add("dragoverFeedback");
		else
			theCanvas.classList.remove("dragoverFeedback");
	}
	
	//------------------------------------------------------------------------------------
	//	Find Bounds
	//		Find the minimum and maximum x and y values across all of the polygons
	//------------------------------------------------------------------------------------
	var FindPolygonListBounds = function(polygonList)
	{
		let maxcb = ( max, cur ) => Math.max( max, cur );
		let mincb = ( max, cur ) => Math.min( max, cur );
	
		let bounds = {min:{x:Infinity, y:Infinity}, max:{x:-Infinity, y:-Infinity}};
	
		polygonList.polygons.forEach(poly =>
		{
			bounds.min.x = poly.points.map(pt => pt.x).reduce( mincb, bounds.min.x );
			bounds.min.y = poly.points.map(pt => pt.y).reduce( mincb, bounds.min.y );
			bounds.max.x = poly.points.map(pt => pt.x).reduce( maxcb, bounds.max.x );
			bounds.max.y = poly.points.map(pt => pt.y).reduce( maxcb, bounds.max.y );
		});
	
		return bounds;
	}

	//------------------------------------------------------------------------------------
	//	Are Valid Bounds?
	//		Returns true if the bounds contain valid values
	//------------------------------------------------------------------------------------
	var AreValidBounds = function(b)
	{
		return (b != undefined && b.min != undefined && b.max != undefined &&
				isFinite(b.min.x) && isFinite(b.min.y) && isFinite(b.max.x) && isFinite(b.max.y));
	}

	//------------------------------------------------------------------------------
	//	Update UI
	//------------------------------------------------------------------------------
	var UpdateUI = function()
	{
		let width = theSourceBounds.max.x - theSourceBounds.min.x;
		let height = theSourceBounds.max.y - theSourceBounds.min.y;
		
		let msg = width.toFixed(2) + " x " + height.toFixed(2);
		
		let e = document.getElementById("ID_InputSize");
		if (e != undefined)
			e.innerHTML = msg;
	}
	
	
	//------------------------------------------------------------------------------
	//	Update UI
	//------------------------------------------------------------------------------
	var AddPolygonsToCurrentTransform = function(polygonIndexList)
	{
		// Remove the index list from all transform index lists
		for (var i = 1; i < theSettings.transforms.length; i++)
		{
			let transform = theSettings.transforms[i];
			
			polygonIndexList.forEach(idx => { 
					let idxIdx = transform.polygonIdxList.indexOf(idx);
					if (idxIdx != -1)
						transform.polygonIdxList.splice(idxIdx, 1);
				});
		}
		
		// Add the list to the current transform index list
		if (theCurrentTransform.polygonIdxList != undefined)
		{
			polygonIndexList.forEach(idx => { 
					let idxIdx = theCurrentTransform.polygonIdxList.indexOf(idx);
					if (idxIdx == -1)
						theCurrentTransform.polygonIdxList.push(idx);
				});
		}
	}
	
	//------------------------------------------------------------------------------------
	//
	//------------------------------------------------------------------------------------
	var ScaleDesign = function(sourceDesign, scaledWidth, scaledHeight)
	{
		let scaledDesign = JSON.parse(JSON.stringify(sourceDesign));
		
		let sourceBounds = FindDesignBounds(sourceDesign);
		let scaledBounds = {min:{x:0, y:0}, max:{x:scaledWidth, y:scaledHeight}};

		let scaleTransform = new Transform(sourceBounds, scaledBounds);
		
		scaledDesign.polygonList.polygons.forEach(
			poly => poly.points.forEach(pt => Object.assign(pt, scaleTransform.xfrm(pt)))
				);
		
		return scaledDesign;
	}
	
	//------------------------------------------------------------------------------------
	//	Set Polygon List
	//		Sets a new polygon list and updates the bounds and transform accordingly
	//------------------------------------------------------------------------------------
	var SetPolygonList = function(designData)
	{
		theSourceDesign = designData;
		theSourceBounds = FindDesignBounds(theSourceDesign);
	
		ResetDesignSettings();

		UpdateUI();
		
		UpdateDesign();

		SetTransformZoom("zoomToDesign", 20);
	}
	
	//------------------------------------------------------------------------------------
	//	Set Transform Zoom
	//------------------------------------------------------------------------------------
	var SetTransformZoom = function(zoomTarget, margin = 0)
	{
	
		if (!isFinite(margin))
			margin = 0;
			
		if (zoomTarget == "zoomToDesign")
		{
			var canvasBounds = {
				min:{x:margin, y:theCanvas.height - margin}, 
				max:{x:theCanvas.width - margin, y:margin}};

			theTransform.CalcMappingTransform(theBounds, canvasBounds);
		}
		else if (zoomTarget == "zoomToPage")
		{
			var canvasBounds = {
				min:{x:margin, y:theCanvas.height - margin}, 
				max:{x:theCanvas.width - margin, y:margin}};
			
// 			let pageSize = {
			let pageBounds = {
				min:{x:-200, y:-200}, 
				max:{x:200, y:200}};

			theTransform.CalcMappingTransform(pageBounds, canvasBounds);
		}
		else
		{
			console.log("SetTransformZoom: not handled: '" + zoomTarget + "'");
		}
	}
	
	//------------------------------------------------------------------------------------
	//
	//------------------------------------------------------------------------------------
	var DidBoundsChange = function(a, b)
	{
		let dx = (a.max.x - a.min.x) - (b.max.x - b.min.x);
		let dy = (a.max.y - a.min.y) - (b.max.y - b.min.y);
		
		return (Math.abs(dx) > epsilon) || (Math.abs(dy) > epsilon);
	}
	
	//------------------------------------------------------------------------------------
	//	Update Design
	//------------------------------------------------------------------------------------
	var UpdateDesign = function()
	{
		theDesign = theSourceDesign;
		
		if (theDesign != undefined)
		{
			if (theSettings.outputSizeEnable)
			{
				theDesign = ScaleDesign(theSourceDesign, theSettings.outputWidth, theSettings.outputHeight);
			}
		
			thePolygonsPath = CreatePolygonsPath(theDesign);

			let oldBounds = theBounds;
			theBounds = thePolygonsPath.FindBounds();
		
			if (oldBounds == undefined)// || DidBoundsChange(oldBounds, theBounds))
				SetTransformZoom("zoomToDesign", 5)
		
			RegenerateDesignPath();
		}
	}
	
	//------------------------------------------------------------------------------------
	//	Regenerate Design Path
	//------------------------------------------------------------------------------------
	var RegenerateDesignPath = function()
	{
		if (theDesign != undefined)
			theDesignDrawing = CreateDesignDrawing(theDesign);
	}

	//------------------------------------------------------------------------------------
	//	Find Design Bounds
	//------------------------------------------------------------------------------------
	var FindDesignBounds = function(designData)
	{
		var bounds = undefined;
	
		for (var i = 0; i < designData.polygonList.polygons.length; i++)
		{
			var p = designData.polygonList.polygons[i];
			bounds = Polygon_FindBounds(p.points, bounds);
		}
	
		return bounds;
	}

	//------------------------------------------------------------------------------------
	//	Create Polygons Path
	//		Sets a new polygon list and updates the bounds and transform accordingly
	//------------------------------------------------------------------------------------
	var CreatePolygonsPath = function(designData)
	{
		let path = new GfxPath();
		
		// For each polygon in the polygon list
		for (var j = 0; j < designData.polygonList.polygons.length; j++)
		{
			let poly = designData.polygonList.polygons[j];
			
			// ...using the points in the polygon...
			for (var i = 0; i < poly.points.length; i++)
			{
				if (i == 0)
					path.MoveTo(poly.points[i]);
				else
					path.LineTo(poly.points[i]);
			}

			// ...and connect the last point back to the first
			path.Close();
		}
		
		return path;
	}

	//------------------------------------------------------------------------------------
	//	Create Design Path
	//		Sets a new polygon list and updates the bounds and transform accordingly
	//------------------------------------------------------------------------------------
	var GetPolygonIndexList = function(designData, transformSettings)
	{
		if (transformSettings.polygonIdxList != undefined)
		{
			return transformSettings.polygonIdxList;
		}
		else
		{
			var allOthersIdxList = [];
			for (var i = 0; i < designData.polygonList.polygons.length; i++)
				allOthersIdxList.push(i);
				
			for (var i = 1; i < theSettings.transforms.length; i++)
			{
				let transform = theSettings.transforms[i];
			
				transform.polygonIdxList.forEach(idx => 
					{ 
						let idxIdx = allOthersIdxList.indexOf(idx);
						if (idxIdx != -1)
							allOthersIdxList.splice(idxIdx, 1);
					});
			}
			
			return allOthersIdxList;
		}
	}
	
	/*
	var UpdateDesignColorAndLine = function()
	{
		// For each polygon in the polygon list
		for (var k = 0; k < theSettings.transforms.length; k++)
		{
			let polygonTransform = theSettings.transforms[k];
			let pathId = "set_" + k;
			let pathSettings = theDesignDrawing.GetGfxPathById(k);
			if (pathSettings != undefined)
			{
				pathSettings.strokeWidth = polygonTransform.lineWidth;
				pathSettings.strokeColor = polygonTransform.lineColor;
			}
		}
	}
	*/
	
	var CreateDesignDrawing = function(designData)
	{
		let drawing = new GfxDrawing();
		let lineWidth = theSettings.transforms[0].lineWidth
		let pathSettings = { strokePath:true, strokeColor:"#000000", strokeWidth:lineWidth };
		
		// For each polygon in the polygon list
		for (var k = 0; k < theSettings.transforms.length; k++)
		{
			let polygonTransform = theSettings.transforms[k];
			let tIdx = polygonTransform.transformIdx;
			if (tIdx < 0 || tIdx >= plotList.length || !isFinite(tIdx))
			{
				console.log("CreateDesignDrawing: polygonTransform.transformIdx invalid: '" + tIdx + "'");
				console.log(JSON.stringify(polygonTransform));
				tIdx = 0;
			}
			
			let plotFunc = plotList[tIdx].func;
			pathSettings.strokeWidth = polygonTransform.lineWidth;
			pathSettings.strokeColor = polygonTransform.lineColor;
			
			let polygonIdxList = GetPolygonIndexList(designData, polygonTransform);
			
			for (var j = 0; j < polygonIdxList.length; j++)
			{
				let polyIdx = polygonIdxList[j];
				let path = new GfxPath();
				
				let poly = designData.polygonList.polygons[polyIdx];
				if (polygonTransform.offset != 0)
				{
					poly = Object.assign({}, poly);
					poly.points = MathUtil.CalcOffsetPolygon(poly.points, polygonTransform.offset);
				}
			
				try {
					if (poly.points.length > 2 && (poly.info == undefined || !poly.info.isFrame))
						plotFunc(path, poly, polygonTransform);
				}
				catch (err) {console.log(err)}
			
				drawing.AddPath(path, pathSettings);
			}
		}
		
		if (theSettings.includePolygons)
		{
			pathSettings.strokeWidth = theSettings.polygonLineWidth;
			pathSettings.strokeColor = theSettings.polygonLineColor;
			let path = new GfxPath();
			for (var j = 0; j < designData.polygonList.polygons.length; j++)
			{
				let poly = designData.polygonList.polygons[j];
				if (poly.points.length > 2 && (poly.info == undefined || !poly.info.isFrame))
					DrawClosedPoly(path, poly.points);
			}
			drawing.AddPath(path, pathSettings);
		}
		
		if (theSettings.includeFrame)
		{
			pathSettings.strokeWidth = theSettings.frameLineWidth;
			pathSettings.strokeColor = theSettings.frameLineColor;
			let path = new GfxPath();
			for (var j = 0; j < designData.polygonList.polygons.length; j++)
			{
				let poly = designData.polygonList.polygons[j];
				if (poly.points.length > 2 && (poly.info != undefined && poly.info.isFrame))
					DrawClosedPoly(path, poly.points);
			}
			drawing.AddPath(path, pathSettings);
		}
		
		return drawing;
	}

	//------------------------------------------------------------------------------------
	//	Load File
	//------------------------------------------------------------------------------------
	var LoadFile = function(file)
	{
		var reader = new FileReader();
		reader.onload = evt => { ProcessPossibleJSON(evt.target.result)};
		reader.readAsText(file);
	}
	
	//------------------------------------------------------------------------------------
	//	Process Possible JSON
	//		Accepts a string and tries to convert it to an object and verify that it
	//		contains polygon data.
	//------------------------------------------------------------------------------------
	var ProcessPossibleJSON = function(s)
	{
		let obj = undefined;
		let bounds = undefined;
		let msg = undefined;
		let polygonDesignData = undefined;
		let settingsData = undefined;
		
		// First, attempt to parse the string as JSON
		try {
			obj = JSON.parse(s);
		}
		catch (err) {
			msg = "Could not parse JSON";
		}
		
		// If we parsed the string, see if we can find the bounds. This
		// indicates that there are polygons with points
		//if (obj)
		//	console.log(JSON.stringify(Object.keys(obj)));
			
		if (obj != undefined && (obj.polygonList || obj.theSourceDesign))
		{
			if (obj.polygonList)
			{
				polygonDesignData = obj;
			}
			else
			{
				polygonDesignData = obj.theSourceDesign;
				settingsData = obj.theSettings;
			}
				
			try {
				bounds = FindPolygonListBounds(polygonDesignData.polygonList);

				// Verify that the bounds are valid
				if (!AreValidBounds(bounds))
				{
					obj = undefined;
					msg = "Could not find bounds of polygons";
				}
			}
			catch (err) {
				msg = "Could not find polygons";
				obj = undefined;
			}
		}
		
		// Everything seems ok, so accept the object as a polygon list
		if (obj != undefined)
		{
			AcceptPolygonDesignData(polygonDesignData, settingsData);
		}
		// Otherwise report the message
		else
		{
			ReportMessage(msg);
		}
	}

	//------------------------------------------------------------------------------------
	//	Accept Polygon List
	//------------------------------------------------------------------------------------
	var AcceptPolygonDesignData = function(design, settings = undefined)
	{
		SetPolygonList(design);
		
		if (settings != undefined)
		{
			SetDesignSettings(settings);
			UpdateDesign();
			SetTransformZoom("zoomToDesign", 20);
		}
		
		// Show the unmodified design
		RenderDesign();
	}

	//------------------------------------------------------------------------------------
	//	Report Message
	//------------------------------------------------------------------------------------
	var ReportMessage = function(msg)
	{
		let e = document.getElementById("ID_Message");
		if (e != undefined)
		{
			e.innerHTML = msg;
			// Remove the message after a few seconds
			setTimeout(e => {e.innerHTML = ""}, 2000, e);
		}
	}
	
	//------------------------------------------------------------------------------------
	//	Render
	//------------------------------------------------------------------------------------
	var RenderDesign = function()
	{
		theContext.clearRect(0, 0, theContext.canvas.width, theContext.canvas.height);

		theContext.strokeStyle = "black";
		theContext.fillStyle = "black";
		theContext.lineWidth = 1.0;

		if (theSettings.showPages)
			RenderPaperSizes();

		if (theDesignDrawing != undefined)
		{
			theContext.lineJoin = "round";
			theContext.lineCap = "round";
			GfxRender.RenderGfxDrawing(theContext, theDesignDrawing, theTransform);
			theContext.lineJoin = "miter";
			theContext.lineCap = "butt";
			
			/*
			for (var i = 0; i < theTestPolygons.length; i++)
			{
				theContext.lineWidth = theTransform.scaleNum(1);
				theContext.strokeStyle = "rgba(0, 255, 0, 0.5)";

				// Create a path
				theContext.beginPath();
			
				let poly = theDesign.polygonList.polygons[theTestPolygons[i]];
				for (var j = 0; j < poly.points.length; j++)
				{
					let pt = theTransform.xfrm(poly.points[j]);
					if (j==0)
						theContext.moveTo(pt.x, pt.y);
					else
						theContext.lineTo(pt.x, pt.y);
				}
				theContext.closePath();
				theContext.stroke();
				
				theContext.lineWidth = 1.0;
			}
			
			for (var i = 0; i < theTestIntersections.length; i++)
			{
				let pt = theTransform.xfrm(theTestIntersections[i]);
				let r = theTransform.scaleNum(1);
				
				theContext.fillStyle = "rgba(255, 0, 0, 0.5)";
				theContext.beginPath();
				theContext.arc(pt.x, pt.y, r, 0, 2 * Math.PI);
				theContext.fill();
			}
			if (theDesignTestPt != undefined)
			{
				let pt = theTransform.xfrm(theDesignTestPt);
				let r = theTransform.scaleNum(1.5);
				
				theContext.fillStyle = "rgba(255, 0, 255, 0.5)";
				theContext.beginPath();
				theContext.arc(pt.x, pt.y, r, 0, 2 * Math.PI);
				theContext.fill();
			}
			theContext.fillStyle = "#000";
			*/
			
			for (var i = 0; i < theHoverPolygons.length; i++)
			{
				theContext.lineWidth = theTransform.scaleNum(1.0);
				theContext.strokeStyle = "rgba(0, 0, 255, 0.5)";

				// Create a path
				theContext.beginPath();
			
				let poly = theDesign.polygonList.polygons[theHoverPolygons[i]];
				for (var j = 0; j < poly.points.length; j++)
				{
					let pt = theTransform.xfrm(poly.points[j]);
					if (j==0)
						theContext.moveTo(pt.x, pt.y);
					else
						theContext.lineTo(pt.x, pt.y);
				}
				theContext.closePath();
				theContext.stroke();
				
				theContext.lineWidth = 1.0;
				
			}
		}
		else if (thePolygonsPath != undefined)
		{
			theContext.lineWidth = 1.0;
			theContext.lineJoin = "miter";// "bevel" || "round" || "miter";
			theContext.lineCap = "butt";//"butt" || "round" || "square";
			GfxRender.RenderGfxPath(theContext, thePolygonsPath, theTransform);
		}
		else
			RenderDragMessage();
	}
	
	//------------------------------------------------------------------------------------
	//	Render Polygons
	//------------------------------------------------------------------------------------
	var RenderPolygons = function()
	{
		theContext.clearRect(0, 0, theContext.canvas.width, theContext.canvas.height);

		if (thePolygonsPath != undefined)
		{
			theContext.lineWidth = 1.0;
			GfxRender.RenderGfxPath(theContext, thePolygonsPath, theTransform);
		}
		else
			RenderDragMessage();
	}
	
	//------------------------------------------------------------------------------------
	//	Render Drag Message
	//------------------------------------------------------------------------------------
	var RenderDragMessage = function()
	{
		theContext.font = '18px serif';
		theContext.fillText(noPolygonsMsg, 20, 50);
	}
	
	//------------------------------------------------------------------------------------
	//	Scale Pt to Canvas
	//------------------------------------------------------------------------------------
	var ScalePtToCanvas = function(pt)
	{
		let x = theTransform.scale.x * pt.x + theTransform.offset.x;
		let y = theTransform.scale.y * pt.y + theTransform.offset.y;
		
		return {x, y};
	}

	//------------------------------------------------------------------------------------
	//	Render Polygons
	//------------------------------------------------------------------------------------
	var RenderPolygons_orig = function(design)
	{
		// For each polygon in the polygon list
		for (var j = 0; j < design.polygonList.polygons.length; j++)
		{
			let poly = design.polygonList.polygons[j];
			
			// Create a path...
			theContext.beginPath();
		
			// ...using the points in the polygon...
			for (var i = 0; i < poly.points.length; i++)
			{
				let pt = ScalePtToCanvas(poly.points[i]);
				if (i == 0)
					theContext.moveTo(pt.x, pt.y);
				else
					theContext.lineTo(pt.x, pt.y);
			}

			// ...and connect the last point back to the first
			theContext.closePath();
			
			// If the polygon has color info, then set the fill style
			// to the color and perform a fill
			if (poly.info != undefined && poly.info.color != undefined)
			{
				theContext.fillStyle = poly.info.color;
				theContext.fill();
			}
			// Otherwise just stroke the polygon
			else
			{
				theContext.stroke();
			}
		}
	}
	
	
	//------------------------------------------------------------------------------------
	//	Move To
	//		Scales the points to the canvas and calls moveTo
	//------------------------------------------------------------------------------------
	var MoveTo = function(pt)
	{
		pt = ScalePtToCanvas(pt);
		theContext.moveTo(pt.x, pt.y);
	}

	//------------------------------------------------------------------------------------
	//	Line To
	//		Scales the points to the canvas and calls lineTo
	//------------------------------------------------------------------------------------
	var LineTo = function(pt)
	{
		pt = ScalePtToCanvas(pt);
		theContext.lineTo(pt.x, pt.y);
	}
	
	//------------------------------------------------------------------------------------
	//	Draw Closed Poly
	//		Calls MoveTo and LineTo for the points of the polygon
	//------------------------------------------------------------------------------------
	var DrawClosedPoly = function(path, points)
	{
		path.MoveTo(points[0]);
		
		for (var i = 1; i < points.length; i++)
			path.LineTo(points[i]);
		
		path.Close();
	}
	
	//------------------------------------------------------------------------------------
	//	Calc Point Between
	//		Return a point between two points, according to a value from 0.0 to 1.0
	//		Can also be called with values outside of this range to get points before
	//		or after the line
	//------------------------------------------------------------------------------------
	var CalcPointBetween = function(ptA, ptB, t)
	{
		let x = t * ptA.x + (1 - t) * ptB.x;
		let y = t * ptA.y + (1 - t) * ptB.y;
		
		return {x, y};
	}

	//------------------------------------------------------------------------------------
	//	Distance Between
	//		Calculates the distance between two points
	//------------------------------------------------------------------------------------
	var DistanceBetween = function(ptA, ptB)
	{
		let x = ptA.x - ptB.x;
		let y = ptA.y - ptB.y;
		
		return Math.sqrt(x*x + y*y);
	}
	
	//------------------------------------------------------------------------------------
	//	Unit Vectors
	//		Returns a unit vector pointing from A to B
	//------------------------------------------------------------------------------------
	var UnitVector = function(ptA, ptB)
	{
		let d = DistanceBetween(ptA, ptB);
		
		let x = ptB.x - ptA.x;
		let y = ptB.y - ptA.y;
		
		return {x:x/d, y:y/d};
	}
	
	//------------------------------------------------------------------------------------
	//	Calc Approximate Center (of a polygon)
	//		Find the approximate center of a polygon by averaging all of the points
	//------------------------------------------------------------------------------------
	var CalcApproximateCenter = function(points)
	{
		let ctr = {x:0, y:0};
		
		points.forEach(pt => { ctr.x += pt.x; ctr.y += pt.y });
		ctr.x /= points.length;
		ctr.y /= points.length;
		
		return ctr;
	}
	
	//------------------------------------------------------------------------------------
	//	Plot: Basic
	//		Simply draws the polygon
	//------------------------------------------------------------------------------------
	var PolygonDesign_Basic = function(gfxPath, poly)
	{
		DrawClosedPoly(gfxPath, poly.points);
	}

	//------------------------------------------------------------------------------------
	//	Plot: Line To Center
	//		Draws lines from the edges of the to the center
	//------------------------------------------------------------------------------------
	var PolygonDesign_LineToCenter = function(gfxPath, poly)
	{
		let polyCtr = (poly.info && poly.info.ctr ? poly.info.ctr : CalcApproximateCenter(poly.points));
		let sp = 10 * theSettings.tParam;
		
		if (sp < 0.1)
			sp = 0.1;
		
		for (var i = 0; i < poly.points.length; i++)
		{
			let ptA = poly.points[i];
			let ptB = poly.points[(i + 1) % poly.points.length];
			let d = DistanceBetween(ptA, ptB);
			let u = UnitVector(ptA, ptB);
			
			var count = Math.floor(d/sp);
			
			if (count > 1)
			{
				for (var j = 1; j < count; j++)
				{
					let pt = CalcPointBetween(ptA, ptB, j/count);
					gfxPath.MoveTo(polyCtr);
					gfxPath.LineTo(pt);
				}
			}
			
			gfxPath.MoveTo(polyCtr);
			gfxPath.LineTo(poly.points[i]);
		}
	}


	//------------------------------------------------------------------------------------
	//	Plot: Twist
	//		Twists the polygon if there is a color. The amount of twisting depends
	//		on the brightness
	//------------------------------------------------------------------------------------
	var PlotPolygon_Twist = function(poly, mode)
	{
		let gray = (poly.info && poly.info.gray != undefined) ? poly.info.gray : -1;
		let len = poly.points.length;
		let count = 0;
		
 		DrawClosedPoly(poly.points);
		
		theContext.lineWidth = 0.5;

		var ptsA = poly.points;
		var ptsB = [];
		
		if (gray != -1 && gray != 255)
		{
			let g = 256 - gray; // map 0..255 => 256..1
			let h = Math.floor( (g * 10) / 256 + 2); // map 256..1 => 10..0 ==> 12..2
			var t = 1/h;
			
			if (h > 2)
			{
				do
				{
					for (var i = 0; i < len; i++)
						ptsB[i] = CalcPointBetween(ptsA[i], ptsA[(i + 1) % len], t);

					DrawClosedPoly(ptsB);
		
					ptsA = ptsB.map(pt => {return {x:pt.x, y:pt.y}});
					count++;
				}
				while (DistanceBetween(ptsA[0], ptsA[1]) > 2 && count < 100);
			}
		}
		
		return (mode == 1) ? undefined : "#000000";
	}

	//------------------------------------------------------------------------------------
	//	Design: Twist Always
	//------------------------------------------------------------------------------------
	var PolygonDesign_TwistAlways = function(path, poly, mode)
	{
		let len = poly.points.length;
		let count = 0;
		var t = 0.2;
		
		t = theSettings.tParam;
		
 		DrawClosedPoly(path, poly.points);
		
		var ptsA = poly.points;
		var ptsB = [];
		
		do
		{
			for (var i = 0; i < len; i++)
				ptsB[i] = CalcPointBetween(ptsA[i], ptsA[(i + 1) % len], t);

			DrawClosedPoly(path, ptsB);

			ptsA = ptsB.map(pt => {return {x:pt.x, y:pt.y}});
			count++;
		}
		while (DistanceBetween(ptsA[0], ptsA[1]) > 2 && count < 100);
	}

	var PolygonSelfIntersects = function(points)
	{
		var selfIntersects = false;
		
		let len = points.length;
		
		for (var i = 0; i < len && !selfIntersects; i++)
		{
			let ptAa = points[i];
			let ptAb = points[(i + 1) % len];
			for (var j = i + 1; j < len && !selfIntersects; j++)
			{
				let ptBa = points[j];
				let ptBb = points[(j + 1) % len];
				
				let c = MathUtil.CalcSegmentIntersection(ptAa, ptAb, ptBa, ptBb);
				
				selfIntersects = (c != undefined);
			}
		}
		
		return selfIntersects;
	}
	
	//------------------------------------------------------------------------------------
	//	Design: Twist Always 2
	//------------------------------------------------------------------------------------
	var PolygonDesign_TwistAlways2 = function(path, poly, mode)
	{
		let len = poly.points.length;
		let count = 0;
		var t = 0.2;
		
		t = theSettings.tParam;
		
 		DrawClosedPoly(path, poly.points);
		
		var ptsA = poly.points;
		var ptsB = [];
		var info = [];
		var someConcave = false;
		
		do
		{
			// Find the angles
			for (var i = 0; i < len; i++)
			{
				let p0 = ptsA[(i + len - 1) % len];
				let p1 = ptsA[i];
				let p2 = ptsA[(i + 1) % len];
				let a = MathUtil.CalcVertexAngle(p0, p1, p2);
				info[i] = {angle:a};
			}
			
			// If all of the angles are concave, then exit
			if (!info.some(e => e.angle > 0))
			{
				console.log("all concave");
				break;
			}
			
			someConcave = info.some(e => e.angle < 0);

			// For all of the convex angles, find the offset point
			for (var i = 0; i < len; i++)
			{
				if (info[i].angle >= 0)
					ptsB[i] = CalcPointBetween(ptsA[i], ptsA[(i + 1) % len], (1-t));
				else
					ptsB[i] = undefined;
			}
			
			while (ptsB.some(p => p == undefined))
			{
				// Find a vertex where the next vertex has a calculated point
				var idx = 0;
				while ((ptsB[idx] != undefined) || (ptsB[idx] == undefined && ptsB[(idx + 1) % len] == undefined))
					idx++;
				
				var pA = ptsB[(idx + 1) % len];
				var pD = ptsA[idx];
				var pt = {};
				pt.x = (pD.x - t * pA.x)/(1 - t);
				pt.y = (pD.y - t * pA.y)/(1 - t);
				ptsB[idx] = pt;
			} 
			
			if (!someConcave || !PolygonSelfIntersects(ptsB))
				DrawClosedPoly(path, ptsB);
			else if (!PolygonSelfIntersects(ptsB))
				break;
	
			ptsA = ptsB.map(pt => {return {x:pt.x, y:pt.y}});
			count++;
		}
		while (DistanceBetween(ptsA[0], ptsA[1]) > 2 && ((!someConcave && count < 100) || (someConcave && count < 10) ) );
	}

	var PolygonDesign_TwistAlways3 = function(path, poly, mode)
	{
		let len = poly.points.length;
		let count = 0;
		var t = 0.2;
		
		t = theSettings.tParam;
		
 		DrawClosedPoly(path, poly.points);
		
		var ptsA = poly.points;
		var ptsB = [];
		var info = [];
		var someConcave = false;
		
		do
		{
			// Find the angles
			for (var i = 0; i < len; i++)
			{
				let p0 = ptsA[(i + len - 1) % len];
				let p1 = ptsA[i];
				let p2 = ptsA[(i + 1) % len];
				let a = MathUtil.CalcVertexAngle(p0, p1, p2);
				info[i] = {angle:a};
			}
			
			// If all of the angles are concave, then exit
			if (!info.some(e => e.angle > 0))
			{
				console.log("all concave");
				break;
			}
			
			someConcave = info.some(e => e.angle < 0);

			// For all of the convex angles, find the offset point
			for (var i = 0; i < len; i++)
			{
				if (info[i].angle >= 0)
					ptsB[i] = CalcPointBetween(ptsA[i], ptsA[(i + 1) % len], (1-t));
				else
					ptsB[i] = ptsA[i];
			}
			
			
			DrawClosedPoly(path, ptsB);
	
			ptsA = ptsB.map(pt => {return {x:pt.x, y:pt.y}});
			count++;
		}
		while (DistanceBetween(ptsA[0], ptsA[1]) > 2 && ((!someConcave && count < 100) || (someConcave && count < 30) ) );
	}

	//------------------------------------------------------------------------------------
	//	Design: Spiral
	//------------------------------------------------------------------------------------
	var PolygonDesign_Spiral = function(path, poly, mode)
	{
		let polyCtr = (poly.info && poly.info.ctr ? poly.info.ctr : CalcApproximateCenter(poly.points));
		let len = poly.points.length;
		
		let d = 0;
		var pt;

		// Find average distance to center
		poly.points.forEach(pt => { d += DistanceBetween(pt, polyCtr)} );
		d /= len;
	
		
		let minSpacing = 0.5;
		let refSpacing = 10.0;
		let sp = minSpacing + refSpacing * theSettings.tParam;
		let loops = d / sp;
		
		if (loops < 1 || !isFinite(loops))
			loops = 1;
		
		//let maxLoops = 8;
		//let loops = 1 + maxLoops * theSettings.tParam;

		let steps = Math.floor(loops * len);
		let s = 1/(steps);

		let count = 0;
		
		path.MoveTo(poly.points[0]);
		do
		{
			pt = CalcPointBetween(poly.points[count % len], polyCtr, (steps - count) * s);
			path.LineTo(pt);
			count++;
		}
		while (/*DistanceBetween(pt, polyCtr) > 2 &&*/ count < steps);
	}

	//------------------------------------------------------------------------------------
	//	Design: Strings
	//------------------------------------------------------------------------------------
	var PolygonDesign_Strings = function(path, poly, mode)
	{
		let len = poly.points.length;
		let count = 0;
		var t = theSettings.tParam;
		
		var steps = 9;
		
		if (t < 0.05)
			t = 0.05;
		
		steps = Math.floor(40 * t);
		
		var ptsA = poly.points;
		
		DrawClosedPoly(path, poly.points);
		
		for (var i = 1; i < steps; i++)
		{
			for (var j = 0; j < len; j++)
			{
				var addLine = true;
				let r = i/steps;
				let p0 = ptsA[j];
				let p1 = ptsA[(j + 1) % len];
				let p2 = ptsA[(j + 2) % len];
				let p3 = ptsA[(j + 3) % len];
				var ptA, ptB;
				
				if (mode == 1)
				{
					ptA = CalcPointBetween(p0, p1, r);
					ptB = CalcPointBetween(p1, p2, r);
				}
				else if (mode == 2)
				{
					ptA = CalcPointBetween(p0, p2, r);
					ptB = CalcPointBetween(p1, p3, r);
				}
				else if (mode == 3)
				{
					ptA = CalcPointBetween(p0, p1, r);
					ptB = CalcPointBetween(p2, p3, r);
				}
				else if (mode == 4)
				{
					let a = MathUtil.CalcVertexAngle(p0, p1, p2);
					
					if (a > 0)
					{
						ptA = CalcPointBetween(p0, p1, r);
						ptB = CalcPointBetween(p1, p2, r);
					}
					else
					{
						addLine = false;
						let d = Math.floor(a * 180.0 / Math.PI);
						//console.log(d);
					}
				}

				if (addLine)
				{
					path.MoveTo(ptA);
					path.LineTo(ptB);
				}
			}
		}
	}

	//------------------------------------------------------------------------------------
	//	Plot: Render Polygons
	//------------------------------------------------------------------------------------
	/*
	function Plot_RenderPolygons(design)
	{
		return;
		
		theContext.clearRect(0, 0, theContext.canvas.width, theContext.canvas.height);

		// Render each polygon
		let len = design.polygonList.polygons.length
		for (var i = 0; i < len; i++)
		{
			// Get the polygon from the list
			var poly = design.polygonList.polygons[i];
			var color;
			
			// Reset the line width. The plotFunc might change it.
			theContext.lineWidth = 1.0;
			
			// Create a path
			theContext.beginPath();
			
			// Create the path for the polygon, but skip the frame, if it
			// is identified. Also, catch any errors.
			try {
				if (poly.points.length > 2 && (poly.info == undefined || !poly.info.isFrame))
					color = plotFunc(poly, 0);
			}
			catch (err) {}
			
			// Use either the color returned from the plot function, the color
			// stored with the polygon, or black
			if (color != undefined)
				theContext.strokeStyle = color;
			else if (poly.info != undefined && poly.info.color != undefined)
				theContext.strokeStyle = poly.info.color;
			else
				theContext.strokeStyle = "black";

			theContext.stroke();
		};
	}
	*/

	//------------------------------------------------------------------------------------
	//	Render Paper Sizes
	//------------------------------------------------------------------------------------
	var RenderPaperSizes = function()
	{
		let inToMM = 25.4;
		let lineWidth = 0.5;
		let centerPages = theSettings.centerDesign;
	
		let defaultPaperSizes = 
		[
			{x: 8.5,  y: 11,  units:"in", name:"Letter" },
			{x: 297,  y: 420, units:"mm", name:"A3" },
			{x: 210,  y: 297, units:"mm", name:"A4" },
			{x: 12,   y: 12,  units:"in", name:"12\"x12\"" }
		]
		
		var paperSizes = [];
		defaultPaperSizes.forEach(p => paperSizes.push(p));
		
		if (theSettings.outputSizeEnable)
			paperSizes.push({x:theSettings.outputWidth, y:theSettings.outputHeight, units:"mm", name:"custom"}); 
	
		var bounds = theBounds;
		var corner = (bounds != undefined) ? bounds.min : {x: 0, y: 0};
		var center = (bounds != undefined) ? {x:(bounds.min.x + bounds.max.x)/2, y:(bounds.min.y + bounds.max.y)/2} : {x: 0, y: 0};
	
	
		lineWidth = theTransform.scaleNum(lineWidth);
		corner = theTransform.xfrm(corner); 
		center = theTransform.xfrm(center); 
	
		theContext.strokeStyle = "rgba(192, 192, 255, 1.0)";
		theContext.fillStyle = "rgba(0, 0, 255, 0.5)";
		theContext.lineWidth = lineWidth;
		theContext.font = '16px sans-serif';
	
		let vInset = lineWidth + 2;
		let hInset = lineWidth + 2;
	
		for (var i = 0; i < paperSizes.length; i++)
		{
			let paper = paperSizes[i];
			let scale = (paper.units == "in") ? inToMM : 1.0;
			let width  = theTransform.scaleNum(paper.x * scale);
			let height = theTransform.scaleNum(paper.y * scale);
		
		
			if (centerPages)
			{
				theContext.strokeRect(center.x - width/2, center.y - height/2, width, height);
				if (paper.name != undefined)
				{
					var m = theContext.measureText(paper.name);
					theContext.fillText(paper.name, center.x - width/2 - m.width - hInset, center.y + height/2 - vInset);
				}
			}
			else
			{
				theContext.strokeRect(corner.x, corner.y - height, width, height);
				if (paper.name != undefined)
				{
					var m = theContext.measureText(paper.name);
					theContext.fillText(paper.name, corner.x + width - m.width - hInset, corner.y /*+ height*/ - vInset);
				}
			}
		
		}

		theContext.fillStyle = "black";
	}
	
	//------------------------------------------------------------------------------------
	//	Public API
	//------------------------------------------------------------------------------------
	return {
		Init:	Init
	};
}());


//------------------------------------------------------------------------------------
//	Start app on load event
//------------------------------------------------------------------------------------
window.addEventListener("load", event => PolygoniaPolygonsPlot.Init());
